module.exports = __webpack_public_path__ + "./fonts/themifyd41d.eot";